import type {UUID} from 'typings/portaro.be.types';
import type {SutorReportReferencesDataService} from './sutor-report-references.data-service';
import type FinishedResponseInteractionService from 'shared/services/finished-response-interaction.service';

export class SutorReportReferencesService {
    public static serviceName = 'sutorReportReferencesService';

    /*@ngInject*/
    constructor(private finishedResponseInteractionService: FinishedResponseInteractionService,
                private sutorWorkReportsDataService: SutorReportReferencesDataService) {
    }

    public async uploadFilesWithFond(files: File[], fondId: number): Promise<UUID[] | null> {
        try {
            const actionResponse = await this.sutorWorkReportsDataService.createFondRecordsUsingFiles(files, fondId);
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
            return actionResponse.savedObject;
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            return null;
        }
    }
}